import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock, ArrowLeft } from "lucide-react";
import { Logo } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email.trim(), password);
      toast.success("Welcome back");
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A192F] text-white flex flex-col">
      <div className="absolute inset-0 civic-grid opacity-40 pointer-events-none" />
      <div className="relative max-w-6xl mx-auto w-full px-4 sm:px-6 h-16 flex items-center justify-between">
        <Logo light />
        <button onClick={() => navigate("/")} className="inline-flex items-center gap-2 text-sm font-semibold text-slate-400 hover:text-white transition-colors" data-testid="admin-back-home">
          <ArrowLeft size={16} /> Back to site
        </button>
      </div>
      <div className="relative flex-1 flex items-center justify-center px-4">
        <div className="w-full max-w-md">
          <div className="text-center">
            <div className="mx-auto h-14 w-14 rounded-2xl bg-[#12B6CF]/15 border border-[#12B6CF]/40 flex items-center justify-center">
              <Lock className="text-[#12B6CF]" size={24} />
            </div>
            <h1 className="mt-6 font-display font-extrabold text-3xl tracking-tight">Admin sign in</h1>
            <p className="mt-2 text-slate-400 text-sm">Reform UK Solihull · survey responses portal</p>
          </div>
          <form onSubmit={submit} className="mt-8 rounded-2xl bg-white/5 border border-white/10 p-6 space-y-4 backdrop-blur">
            <div>
              <label className="text-sm font-semibold text-slate-300">Email</label>
              <input value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" type="email" required className="mt-2 w-full rounded-xl bg-[#0F213D] border border-white/10 px-4 py-3 text-sm text-white placeholder:text-slate-500 focus:border-[#12B6CF] focus:ring-2 focus:ring-[#12B6CF]/20 outline-none" placeholder="you@example.com" />
            </div>
            <div>
              <label className="text-sm font-semibold text-slate-300">Password</label>
              <input value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" type="password" required className="mt-2 w-full rounded-xl bg-[#0F213D] border border-white/10 px-4 py-3 text-sm text-white placeholder:text-slate-500 focus:border-[#12B6CF] focus:ring-2 focus:ring-[#12B6CF]/20 outline-none" placeholder="••••••••" />
            </div>
            <button type="submit" disabled={loading} data-testid="login-submit" className="w-full rounded-xl bg-[#12B6CF] hover:bg-[#0FA0B7] text-white font-semibold py-3 transition-colors disabled:opacity-60">
              {loading ? "Signing in…" : "Sign in"}
            </button>
          </form>
          <p className="mt-4 text-center text-xs text-slate-500">Authorised personnel only.</p>
        </div>
      </div>
    </div>
  );
}
